<template>
  <select class="form-control" :value="value" @change="onChange">
    <option value="">Select Job Title</option>
    <option v-for="job in jobs" :key="job" :value="job">{{ job }}</option>
  </select>
</template>

<script>
export default {
  name: 'JobTitleSelect',
  props: {
    value: String
  },
  data() {
    return {
      jobs: [
        'Assistant Professor',
        'Associate Professor',
        'Professor Emeritus',
        'Professor',
        'Research/Postdoctoral Fellow',
        'Research Associate/Engineer',
        'Research Scientist',
        'President',
        'Director',
        'Deputy Director',
        'Head of Department',
        'Dean',
        'PhD Candidate',
        'Masters',
        'Undergraduate',
        'High School or Younger',
        'Retiree',
        'Others'
      ]
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script> 